import { render, staticRenderFns } from "./CreateEmailTemplate.vue?vue&type=template&id=ed67458c"
import script from "./CreateEmailTemplate.vue?vue&type=script&lang=js"
export * from "./CreateEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports